export default {
    myPool: {
        RED: {
            '1x': require('../../assets/images/my-pools-red.png'),
            '2x': require('../../assets/images/my-pools-red@2x.png'),
            '3x': require('../../assets/images/my-pools-red@2x.png')
        },
        GREEN: {
            '1x': require('../../assets/images/my-pools-blue.png'),
            '2x': require('../../assets/images/my-pools-blue@2x.png'),
            '3x': require('../../assets/images/my-pools-blue@2x.png')
        },
        YELLOW: {
            '1x': require('../../assets/images/my-pools-night.png'),
            '2x': require('../../assets/images/my-pools-night@2x.png'),
            '3x': require('../../assets/images/my-pools-night@2x.png')
        }
    },
    temp: {
        default: {
            '1x': require('../../assets/images/temp.png'),
            '2x': require('../../assets/images/temp@2x.png'),
            '3x': require('../../assets/images/temp@3x.png')
        }
    },
    viewGraph: {
        default: {
            '1x': require('../../assets/images/view-graphs.png'),
            '2x': require('../../assets/images/view-graphs@2x.png'),
            '3x': require('../../assets/images/view-graphs@3x.png')
        }
    },
    gear: {
        default: {
            '1x': require('../../assets/images/gear-web-app-gray.png'),
            '2x': require('../../assets/images/gear-web-app-gray@2x.png'),
            '3x': require('../../assets/images/gear-web-app-gray@3x.png')
        }
    },
    chevron: {
        default: {
            '1x': require('../../assets/images/Chevron-right.png'),
            '2x': require('../../assets/images/Chevron-right@2x.png'),
            '3x': require('../../assets/images/Chevron-right@3x.png')
        }
    },
    battery: [
        {
            '1x': require('../../assets/images/battImgBar0.png'),
            '2x': require('../../assets/images/battImgBar0@2x.png'),
            '3x': require('../../assets/images/battImgBar0@3x.png')
        },
        {
            '1x': require('../../assets/images/battImgBar1.png'),
            '2x': require('../../assets/images/battImgBar1@2x.png'),
            '3x': require('../../assets/images/battImgBar1@3x.png')
        },
        {
            '1x': require('../../assets/images/battImgBar2.png'),
            '2x': require('../../assets/images/battImgBar2@2x.png'),
            '3x': require('../../assets/images/battImgBar2@3x.png')
        },
        {
            '1x': require('../../assets/images/battImgBar3.png'),
            '2x': require('../../assets/images/battImgBar3@2x.png'),
            '3x': require('../../assets/images/battImgBar3@3x.png')
        },
        {
            '1x': require('../../assets/images/battImgBar4.png'),
            '2x': require('../../assets/images/battImgBar4@2x.png'),
            '3x': require('../../assets/images/battImgBar4@3x.png')
        }
    ],
    logo: {
        default: {
            '1x': require('../../assets/images/WaterGuru-Logo.svg'),
            '2x': require('../../assets/images/WaterGuru-Logo.svg'),
            '3x': require('../../assets/images/WaterGuru-Logo.svg')
        }
    }
}
